import { FC, useEffect, useState } from "react";
import { Layout } from "../../../containers";
import { 
    Title, 
    Card,
    Button,
    Text,
    Modal,
    Loading
} from "../../../components/UI";
import { useEmail } from "../../../hooks/useEmail";

export const AdminMailingPage: FC = () => {
    const { templates, loading, error, getTemplates, sendTestEmail } = useEmail();
    const [emails, setEmails] = useState<string>('');
    const [showModal, setShowModal] = useState(false);
    const [modalMessage, setModalMessage] = useState('');
    const [modalType, setModalType] = useState<'success' | 'error'>('success');
    const [sendingEmailId, setSendingEmailId] = useState<string | null>(null);

    useEffect(() => {
        const savedEmails = localStorage.getItem('testEmails') || '';
        setEmails(savedEmails);
        getTemplates();
    }, []);

    const onChangeEmails = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
        const newEmails = e.target.value;
        setEmails(newEmails);
        localStorage.setItem('testEmails', newEmails);
    }

    const handleSendTest = async (emailId: string) => {
        if (!emails.trim()) {
            setModalType('error');
            setModalMessage('Por favor, ingrese al menos un email');
            setShowModal(true);
            return;
        }

        setSendingEmailId(emailId);
        const response = await sendTestEmail(emails, emailId);
        setSendingEmailId(null);

        setModalType(response.status === 'Ok' ? 'success' : 'error');
        setModalMessage(
            response.status === 'Ok' 
                ? 'Email de prueba enviado exitosamente' 
                : response.message || 'Error al enviar el email'
        );
        setShowModal(true);
    }

    const renderContent = () => {
        if (loading && templates.length === 0) {
            return <Loading />;
        }

        return (
            <>
                <Card className="mt-20 p-30">
                    <Title>Emails para recibir las pruebas</Title>
                    <Text className="mt-10">Si necesitas enviar pruebas a múltiples emails, por favor ingresa los emails separados por coma.</Text>
                    <textarea 
                        className="w-full mt-20 p-10 border rounded" 
                        value={emails} 
                        onChange={onChangeEmails}
                        disabled={!!sendingEmailId}
                        rows={3}
                        placeholder="ejemplo@correo.com, otro@correo.com"
                    />
                </Card>

                {error && (
                    <Card className="mt-20 p-30 bg-red-100">
                        <Text className="text-red-600">{error}</Text>
                    </Card>
                )}

                {templates.length === 0 && !loading && !error && (
                    <Card className="mt-20 p-30">
                        <Text>No hay plantillas de email disponibles</Text>
                    </Card>
                )}

                {templates.map((template) => (
                    <Card key={template.id} className="mt-20 p-30">
                        <Title border>{template.title}</Title>
                        <Text className="mt-10">ID: {template.id}</Text>
                        <Text>{template.description}</Text>
                        <Button 
                            className="mt-10" 
                            onClick={() => handleSendTest(template.id.toString())}
                            disabled={!!sendingEmailId}
                        >
                            {sendingEmailId === template.id.toString() 
                                ? 'Enviando...' 
                                : 'Enviar prueba'
                            }
                        </Button>
                    </Card>
                ))}
            </>
        );
    };

    return (
        <Layout role="ADMIN_ROLE" menu={true}>
            <Title border>Probar Emails</Title>
            
            {renderContent()}

            <Modal 
                show={showModal} 
                onClose={() => setShowModal(false)}
                maxWidth="400px"
            >
                <Card className={`p-20 ${modalType === 'error' ? 'bg-red-100' : 'bg-green-100'}`}>
                    <Text className={modalType === 'error' ? 'text-red-600' : 'text-green-600'}>
                        {modalMessage}
                    </Text>
                </Card>
            </Modal>
        </Layout>
    );
};
